export const isTokenValid = (token: string | null): boolean => {
  if (!token) return false;

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));

    if (payload.exp) {
      const expirationTime = payload.exp * 1000;
      const currentTime = Date.now();

      return currentTime < expirationTime;
    }

    return true;
  } catch (error) {
    console.error("Erro ao validar token:", error);
    return false;
  }
};

export const getToken = (): string | null => {
  return localStorage.getItem("duas-vidas-token");
};

export const getUserIdFromToken = (): string | null => {
  const token = getToken();
  if (!token) return null;

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.sub || payload.userId || payload.id || null;
  } catch (error) {
    console.error("Erro ao extrair userId do token:", error);
    return null;
  }
};

export const removeToken = (): void => {
  localStorage.removeItem("duas-vidas-token");
};

export const saveUserData = (user: any): void => {
  localStorage.setItem("duas-vidas-user", JSON.stringify(user));
};

export const getUserData = (): any | null => {
  const userData = localStorage.getItem("duas-vidas-user");
  if (!userData) return null;
  
  try {
    return JSON.parse(userData);
  } catch (error) {
    console.error("Erro ao parsear dados do usuário:", error);
    return null;
  }
};

export const removeUserData = (): void => {
  localStorage.removeItem("duas-vidas-user");
};

export const clearAuthData = (): void => {
  removeToken();
  removeUserData();
};
